var React = require('react');

function ArrowRightBlack (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"square"},React.createElement("g",{"id":"home","transform":"translate(-789.000000, -4075.000000)","stroke":"#454D58"},React.createElement("g",{"id":"Group-27-Copy","transform":"translate(790.000000, 4074.000000)"},[React.createElement("path",{"d":"M0,13 L34,13","id":"Line-5","key":0}),React.createElement("g",{"id":"Group-26","transform":"translate(22.000000, 0.000000)","key":1},[React.createElement("path",{"d":"M-1.78248558,7 L15.2175144,7","id":"Line-5","transform":"translate(6.717514, 7.000000) rotate(-315.000000) translate(-6.717514, -7.000000) ","key":0}),React.createElement("path",{"d":"M-1.78248558,19 L15.2175144,19","id":"Line-5","transform":"translate(6.717514, 19.000000) rotate(-225.000000) translate(-6.717514, -19.000000) ","key":1})])]))));
}

ArrowRightBlack.defaultProps = {"width":"37px","height":"24px","viewBox":"0 0 37 24","version":"1.1"};

module.exports = ArrowRightBlack;

ArrowRightBlack.default = ArrowRightBlack;



//////////////////
// WEBPACK FOOTER
// ./src/assets/global-logos/arrow/arrow-right-black.svg
// module id = 182
// module chunks = 35783957827783 140935043865547